export const GET_FLOW_BY_TENANT_ID = `
query getFlowByTenantId ($input: GetFlowByTenantIdInput!) {
	getFlowByTenantId(input: $input) {
		__typename
		... on Flow { 
			id
			name
			description
		}
	}
}
`;

export const GET_FLOWS_HISTORY = `
query getFlowsHistory($input: GetFlowsHistoryInput!) {
	getFlowsHistory (input: $input) {
		__typename
		... on FlowInstance {
			id
			flow_id
			flow_name
			flow_instance_status_id
			status
			start_date
			reason
			end_date_instance
		}
	}
}
`;

export const GET_ACTIVE_TASKS_BY_INSTANCE = `
query getActiveActivitiesByInstance ($input: GetActiveActivitiesByInstanceInput!) {
	getActiveActivitiesByInstance(input: $input) {
		
			__typename
			... on FlowActivity {
				id
				flow_id
				name
				description
				documentation {
					nextTask {
						approval
						decline
					}
					description
				}
				sequence_order
				assignee
				due_date
				type {
					id
					name
				}
			}
		
	}
}
`;

export const GET_LAST_FLOWS_ACTIVITIES = `
query getLastFlowsActivities ($input: GetLastFlowsActivitiesInput!) {
	getLastFlowsActivities (input: $input) {
		__typename
		... on FlowActivity {
			id
			flow_id
			name
			description
			type {
				id
				name
			}
			sequence_order
			documentation {
				nextTask {
					approval
					decline
				}
				description
			}
			assignee
			assignee_name
			status {
				id
				name
			}
			start_date
			end_date
			due_date
			flow_name
		}
	}
}
`;
